import { ListItem as ListItemMui, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { AlertBox } from 'components/Box'
import { RelatedList } from 'components/RelatedSettings'
import { UnfilledRecoveryPrebidSettingsWarnings } from 'features/inventory/types/unfilledRecoveryPrebidSettingsWarnings'

const ListItem = ({ content }: { content: string }): JSX.Element => (
  <ListItemMui
    disableGutters
    sx={{ display: 'list-item' }}
  >
    {content}
  </ListItemMui>
)

export const PrebidSettingsAlert = ({
  warnings,
}: {
  warnings: UnfilledRecoveryPrebidSettingsWarnings
}): JSX.Element => {
  const { t } = useTranslation('features/domain', {
    keyPrefix: 'form.unfilledRecovery.prebidSettings.prebidBehaviourType.alert',
  })

  return (
    <AlertBox
      severity='warning'
      sx={{ height: 'fit-content' }}
      title={t('title')}
    >
      <Typography sx={{ fontSize: 'inherit' }}>{t('intro')}</Typography>

      <RelatedList>
        {warnings.prebidStackDisabled && <ListItem content={t('prebidStackDisabled')} />}
        {warnings.recoveryAdUnitNotAdded && <ListItem content={t('recoveryAdUnitNotAdded')} />}
        {warnings.multipleBasePathUnitsDetected && (
          <ListItem content={t('multipleBasePathUnitsDetected')} />
        )}
        {warnings.allRecoveryAdUnitDisabled && (
          <ListItem content={t('allRecoveryAdUnitDisabled')} />
        )}
      </RelatedList>
    </AlertBox>
  )
}
